import { createRoot } from 'react-dom/client'
import { useActionState , useState} from 'react'
import clsx from 'clsx'

async function submitContact(prevState,formData) {
    console.log(formData);
    await fetch('https://skyeanalytics.com/api/',
		{'method': 'POST',
		 body: formData});
    return 'complete';
}

function SectionHeader() {
    return                 <h1 className="font-body text-5xl text-blue-100 md:ml-4 lg:ml-6 md:mb-8 lg:mb-10">
                    Contact Us
			   </h1>;
}
function ContactForm() {
    const [state, formAction, isPending] = useActionState(submitContact,'ready');
    const inputClassName = clsx("block w-full rounded-sm border-2 border-gray-100 invalid:border-red-400 lg:rounded-md",{
	'bg-gray-200 cursor-not-allowed' : isPending
    });
    if(state === 'complete'){
	return <>
		   <SectionHeader />
		   <div id="contact_form_container" className="mx-auto text-center w-fit">
		   <svg
		       xmlns="http://www.w3.org/2000/svg"
		       version="1.1"
		       width={128}
		       height={128}
		       viewBox="0 0 256 256"
		       className="mx-auto"
		   >
		       <g
			   style={{
			       stroke: "none",
			       strokeWidth: 0,
			       strokeDasharray: "none",
			       strokeLinecap: "butt",
			       strokeLinejoin: "miter",
			       strokeMiterlimit: 10,
			       fill: "none",
			       fillRule: "nonzero",
			       opacity: 1
			   }}
			   transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
		       >
			   <polygon
			       points="37.95,64.44 23.78,50.27 30.85,43.2 37.95,50.3 59.15,29.1 66.22,36.17 "
			       style={{
				   stroke: "none",
				   strokeWidth: 1,
				   strokeDasharray: "none",
				   strokeLinecap: "butt",
				   strokeLinejoin: "miter",
				   strokeMiterlimit: 10,
				   fill: "#00aeef",
				   fillRule: "nonzero",
				   opacity: 1
			       }}
			       transform="  matrix(1 0 0 1 0 0) "
			   />
			   <path
			       d="M 45 90 C 20.187 90 0 69.813 0 45 C 0 20.187 20.187 0 45 0 c 24.813 0 45 20.187 45 45 C 90 69.813 69.813 90 45 90 z M 45 10 c -19.299 0 -35 15.701 -35 35 s 15.701 35 35 35 s 35 -15.701 35 -35 S 64.299 10 45 10 z"
			       style={{
				   stroke: "none",
				   strokeWidth: 1,
				   strokeDasharray: "none",
				   strokeLinecap: "butt",
				   strokeLinejoin: "miter",
				   strokeMiterlimit: 10,
				   fill: "#00aeef",
				   fillRule: "nonzero",
				   opacity: 1
			       }}
			       transform=" matrix(1 0 0 1 0 0) "
			       strokeLinecap="round"
			   />
		       </g>
		   </svg>

		   <h2 className="md:text-lg lg:text-xl">Submitted Successfully!</h2>
	       </div></>;
    }
    
    return      <><SectionHeader />
		    <div id="contact_form_contanier">
                    <form className="mx-auto grid grid-cols-2 gap-y-2 lg:w-2/3" action={formAction}>
                        <div className="lg:px-4">
                            <label className="text-right text-sm" htmlFor="fname"
                                >First Name&nbsp;
                            </label>
                            <input
                                className={inputClassName}
                                required
                                type="text"
                                id="fname"
                                name="first_name"
                            />
                        </div>
                        <div className="lg:px-4">
                            <label className="text-right text-sm" htmlFor="lname"
                                >Last Name&nbsp;
                            </label>
                            <input
                                className={inputClassName}
                                required
                                type="text"
                                id="lname"
                                name="last_name"
                            />
                        </div>
                        <div className="col-span-2 lg:px-4">
                            <label className="text-right text-sm" htmlFor="email"
                                >Email&nbsp;
                            </label>
                            <input
                                className={inputClassName}
                                type="text"
                                id="email"
                                name="email_address"
                                required
                            />
                        </div>
                        <div className="col-span-2 lg:px-4">
                            <label className="text-right text-sm" htmlFor="company">
                                Company
                            </label>
                            <input
                                className={inputClassName}
                                type="text"
                                id="company"
                                name="company_name"
				required
                            />
                        </div>
                        <div className="col-span-2 lg:px-4" id="query_text">
                            <label className="text-right text-sm" htmlFor="company">
                                Tell us about your project
                            </label>
                            <textarea
                                rows="5"
                                className={inputClassName}
                                id="query"
				name="description"
                            ></textarea>
                        </div>
                        <div className="col-span-2 lg:mx-auto lg:w-24">
                            <button
                                className="bg-orange w-full cursor-pointer rounded-md text-white transition-all duration-200 hover:bg-gray-100 lg:rounded-lg"
                                type="submit"
                                id="submit"
                            >
                                Submit
                            </button>
			    <svg xmlns="http://www.w3.org/2000/svg" className={clsx("size-5 animate-spin",{"invisible": !isPending})} viewBox="0 0 24 24" fill="none">
<path d="M12 3V6M3 12H6M5.63607 5.63604L7.75739 7.75736M5.63604 18.3639L7.75736 16.2426M21 12.0005H18M18.364 5.63639L16.2427 7.75771M11.9998 21.0002V18.0002M18.3639 18.3642L16.2426 16.2429" stroke="#ed7d31" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
                        </div>
                    </form>
        </div></>;
}

const domNode = document.getElementById('contact_form')
const root = createRoot(domNode)
root.render(<ContactForm />);
